const statusLabels = [
  'no IviumSoft',
  'connected',
  'available_idle',
  'available_busy',
  'no device available',
];

export default statusLabels;
